import React from 'react';

import { LineFeature } from '@foreflight/webmap/core';
import { GeojsonLayer } from '@foreflight/webmap/react';

import { pointToCoordinate } from 'ff/debrief/utils';
import { useDebriefApp } from 'ff/debrief/hooks';
import { SegmentNode } from 'ff/debrief/features/DebriefSegments';

interface Props {
    trackCoords: [number, number][];
    segments?: SegmentNode[];
    selectedSegment?: SegmentNode;
}

const TrackLayer = (props: React.PropsWithChildren<Props>) => {
    const { isDecluttering } = useDebriefApp();
    const isSegmentSelected = Boolean(props.selectedSegment);
    const trackFeature = createTrackFeature(props.trackCoords);
    if (isSegmentSelected && isDecluttering) {
        trackFeature.properties.color = 'rgba(53,199,242,0.15)';
    }
    const segmentFeatures = props.segments.map(segment => {
        const feature = createSegmentFeature(segment);
        if (isSegmentSelected && isDecluttering) {
            feature.properties.color += '25';
        }
        return feature;
    });

    if (isSegmentSelected && isDecluttering) {
        return (
            // @ts-expect-error Issues with webmap exports
            <GeojsonLayer
                features={[
                    trackFeature,
                    ...segmentFeatures,
                    createSegmentFeature(props.selectedSegment),
                ]}
                priority={30}
            />
        );
    } else {
        return (
            // @ts-expect-error Issues with webmap exports
            <GeojsonLayer
                features={[trackFeature, ...segmentFeatures]}
                priority={30}
            />
        );
    }
};

const createTrackFeature = (points: [number, number][]): LineFeature => {
    return {
        type: 'Feature',
        properties: {
            color: 'rgba(53,199,242,1)',
            width: 5,
            cap: 'square',
            outlineColor: '#000',
            outlineWidth: 1,
        },
        geometry: {
            type: 'LineString',
            coordinates: points,
        },
    };
};

function createSegmentFeature(segment: SegmentNode): LineFeature {
    return {
        type: 'Feature',
        properties: {
            color: segment.getColor() || 'rgba(53,199,242,1)',
            width: 5,
            cap: 'square',
            outlineColor: '#000',
            outlineWidth: 1,
        },
        geometry: {
            type: 'LineString',
            coordinates: segment.points.map(pointToCoordinate),
        },
    };
}

export default TrackLayer;
